<template>
  <div class="d-flex text-center py-2">
    <InputFormatadorDeValor
      v-model="linha.quantidade"
      :removerValorIrrelevante="true"
      centralizar
      class="font-12 input-regular"
      :sufixo="linha.idunidade_medida"
      :disabled="data_table_departamentos_carregando_dados"
      @focus="$event.target.select()"
      @blur="salvarEdicaoSugestao"
      @keyup.enter="$event.target.blur()"
      @keydown.prevent.up="incrementarSugestao"
      @keydown.prevent.down="decrementarSugestao"
      @change="sugestao_alterada = true"
    />

    <ValidaLoteMinimo
      v-show="!LOTE_MINIMO_VALIDO && linha.quantidade > 0"
      ref="validadorLoteMinimoRef"
      v-model="linha.quantidade"
      :lote-minimo="linha.lote_minimo"
      @change="sugestao_alterada = true;salvarEdicaoSugestao();"
      @forcar-sugestao="sugestao_alterada = true;linha.comprar_fora_lote_minimo = true;salvarEdicaoSugestao();"
    />

    <v-tooltip v-if="linha.quantidade <= 0" bottom>
      <template v-slot:activator="{on, attrs}">
        <v-btn icon small color="red" v-bind="attrs" v-on="on">
          <v-icon>mdi-alert</v-icon>
        </v-btn>
      </template>
      <span>Quantidade de compra inválida</span>
    </v-tooltip>
  </div>
</template>

<script>
import InputFormatadorDeValor from "../../../../../utils/InputFormatadorDeValor.vue";
import ValidaLoteMinimo from "../../../../ValidaLoteMinimo.vue";
import {NIVEIS_DE_EXPANCAO} from "@/components/utils/dataTable/sysDataTableDepartamentos/NiveisDeExpancao";
import {data_table_departamentos_carregando_dados} from "@/components/utils/dataTable/sysDataTableDepartamentos/CarregandoDados";
import {editarCategoriaNoPedido} from "@/api/compras/MateriaPrima";

export default {
  name: "SugestaoDeCompra",
  mixins: [data_table_departamentos_carregando_dados],
  components: {
    ValidaLoteMinimo,
    InputFormatadorDeValor
  },
  props: {
    linha: {
      type: Object,
      required: true
    }
  },
  data: () => ({
    NIVEIS_DE_EXPANCAO,
    sugestao_alterada: false
  }),
  computed: {
    LOTE_MINIMO_VALIDO() {
      if (!this.linha.lote_minimo) return false;

      const qtd_compra = Number(this.linha.quantidade).toFixed(4);
      const modulo = Number((qtd_compra % this.linha.lote_minimo).toFixed(4));

      return (modulo === 0 || modulo === Number(this.linha.lote_minimo));
    }
  },
  methods: {
    salvarEdicaoSugestao() {
      if (!this.linha.comprar_fora_lote_minimo && !this.LOTE_MINIMO_VALIDO) {
        this.ativarAlertaLoteMinimo();
        return;
      }

      if (!this.sugestao_alterada || this.linha.quantidade <= 0) return;

      const categoria = {
        idcategoria: this.linha.idcategoria,
        id_pedido: this.linha.id_pedido,
        quantidade: this.linha.quantidade
      };

      this.$store.dispatch("loading/addRequisicao",
        editarCategoriaNoPedido(categoria).then(this.salvoComSucesso));
    },
    salvoComSucesso() {
      this.sugestao_alterada = false;
    },
    incrementarSugestao() {
      this.linha.quantidade++;
    },
    decrementarSugestao() {
      this.linha.quantidade--;
    },
    ativarAlertaLoteMinimo() {
      this.$refs.validadorLoteMinimoRef.ativador_menu = true;
    }
  }
}
</script>

<style scoped>
</style>
